import { memo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { COLOR, THEME } from '../../../constants/styles';
import FieldLabel from './field_label';

export default memo((props) => {
  return (
    <View style={[styles.container, props.containerStyle, props.style]}>
      <FieldLabel label={props.label} />
      <View style={props.flexibleLayout ? { paddingTop: 5 } : { height: 40, paddingTop: 5 }}>
        <Text style={THEME.textRegular}>{props.value}</Text>
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    ...THEME.inputContainerDisabled,
    borderBottomWidth: 1,
    marginBottom: 10,
    marginTop: 2,
    paddingVertical: 5,
  },
});
